var $j = jQuery.noConflict();

window.error_message = function (title, content)
{
    var error = $j('#top_error').html();

    error = error.replace('_TITLE', title);

    if (undefined !== content) {
        error = error.replace('_CONTENT', content);
    } else {
        var $error = $j("<div />").append(error);
        $error.find('.content-error').remove();
        error = $error.html();
    }

    $j('#main-container').prepend(error);
}
